import React, { useState } from "react";
import { Box, Flex, Avatar } from "@chakra-ui/react";
import DsrReplyOptionsButton from './DsrReplyOptionsButton';
import { getUserDetailsUsingDsrMembersArray } from '../../profile/helpers/user-helper';
import { getThisUserIdToken, isValidArray } from '../../global/helpers/global-helpers';
import { Mention, MentionsInput } from "react-mentions";
import { mentionStyleInReply } from "../../forms/TextareaField/components/InputTextAreaWithUserTagging";
import PostReplyButtonModule from './PostReplyButtonModule';
import { displayReactIcon } from "../helpers/dsr-display-helpers";
import { displayElapsedDurationSinceTimestamp } from "../../global/helpers/time-format-helpers";


export default function DsrRepliesDisplayModule({
  dsrTeamMembers,
  handleChangeUserActionRequired,
  messageRepliesArray,
  postId,
  onClickDeleteReplyOption,
  confirmationType,
  isStaticMode,
  isMobileView,
  isDsrAdmin,
  dsrId
}) {

  const currentUserId = getThisUserIdToken();
  const [showReplyOptionButton, setShowReplyOptionButton] = useState(null)
  const [showOptionButtonReplyId, setShowOptionButtonReplyId] = useState(null)

  const handleShowReplyOptionsButton = (replyId) => {
    setShowReplyOptionButton(replyId ? true : false)
    setShowOptionButtonReplyId(replyId)
  }

  if (!messageRepliesArray) {
    return null;
  }

  const displayReplies = messageRepliesArray?.map((reply, replyIndex) => {
    const { replyId, replyCreatedAt, replyStatus, replyContent, replyUserId, replyUpdatedAt, flaggedReplyReports } = reply;
    const hasReportedThisPost = isValidArray(flaggedReplyReports) ? flaggedReplyReports.some(obj => obj.reportUserId === currentUserId) : false;

    const userId = getThisUserIdToken();
    const isAuthor = (replyUserId === userId) ? true : false;
    const isEditedReply = (replyUpdatedAt) ? true : false;

    const authorProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, replyUserId);
    const { memberName, memberProfilePicSrc, memberOrgTitle, memberOrgName } = authorProfile || {}
    const additionalInfoDisplay = (memberOrgTitle && memberOrgName) ? memberOrgTitle + ", " + memberOrgName : memberOrgName ? memberOrgName : "";

    if (replyStatus === 'deleted') {
      return null;
    }

    const renderReportedContent = () => {
      return (
        <Flex mt='1em' justify='flex-start' align='center' bg='white' border='1px solid' borderColor='gray.300' rounded='0.5em' p='0.2em 1.25em' gap='0.5em'>
          <Box color='brandPink.500'>{displayReactIcon("alert", "1em")}</Box>
          <Box p='0.5em' fontSize='0.8em'>This reply has been reported & hidden </Box>
        </Flex>
      )
    }

    return (<React.Fragment key={`message_reply_${postId}${replyIndex}`}>
      <Flex px='0.5em' width='100%' mt='1em'
        onMouseOver={() => { handleShowReplyOptionsButton(replyId) }}
        onMouseOut={() => { handleShowReplyOptionsButton("") }}
      >
        <Box pt='0.5em' display={['none', 'block']}>
          <Avatar h='3.5em' w='3.5em' name={memberName} bg='gray.100' color='gray.700' src={memberProfilePicSrc} />
        </Box>

        <Box ml={['0', '0', '0.8em', '0.8em']} p={isMobileView ? '0.5em' : '0.5em 1em'} bg='gray.100' rounded='0.25em' width='100%'>
          <Flex align='flex-start' justify='space-between'>
            <Flex w='100%' align='center'>
              <Box pr='0.5em' display={['block', 'block', 'none', 'none']}>
                <Avatar h='3em' w='3em' name={memberName} bg='gray.100' color='gray.700' src={memberProfilePicSrc} />
              </Box>
              <Flex w='100%' align={['left']} justify='flex-start' direction='column'>
                <Flex w='100%' align='flex-end' justify='space-between'>
                  <Box fontSize='0.8em' fontWeight='600'>{memberName}</Box>
                  {!isStaticMode && !hasReportedThisPost &&
                    <PostReplyButtonModule
                      allowSliding={(!!showReplyOptionButton && showOptionButtonReplyId === replyId) ? true : false}
                      flaggedRepliesReports={flaggedReplyReports}
                      isDsrAdmin={isDsrAdmin}
                      // isAuthor={isAuthor}
                      // isStaticMode={isStaticMode}
                      dsrTeamMembers={dsrTeamMembers}
                    >
                      <DsrReplyOptionsButton
                        dsrId={dsrId}
                        postId={postId}
                        replyId={replyId}
                        isAuthor={isAuthor}
                        isDsrAdmin={isDsrAdmin}
                        onClickDeleteReplyOption={onClickDeleteReplyOption}
                        confirmationType={confirmationType}
                        handleChangeUserActionRequired={handleChangeUserActionRequired}
                        replyObject={reply}
                      />
                    </PostReplyButtonModule>
                  }
                </Flex>
                {additionalInfoDisplay && <Flex justify='flex-start' fontSize='0.65em' color='gray.500'>{additionalInfoDisplay}</Flex>}

                <Flex lineHeight='1em' justify='flex-start' align='center' gap="0.5em" fontSize='0.6em' fontWeight='400' color='gray.500'>
                  <Box >{displayElapsedDurationSinceTimestamp(replyCreatedAt)}</Box>
                  {isEditedReply ? <Box >• Edited</Box> : null}
                </Flex>

              </Flex>
            </Flex>
          </Flex>


          {hasReportedThisPost ?
            renderReportedContent()
            :
            <Box mt='1em' color='brandDark.500' fontSize='0.85em' lineHeight='1.25em' fontWeight='400' className="white-space-preline">
              <MentionsInput
                readOnly={true}
                value={replyContent}
              >
                <Mention
                  markup='@[__display__]userId-(__id__)'
                  style={mentionStyleInReply}
                  displayTransform={(id, display) => { return `@${display}` }}
                />
              </MentionsInput>
            </Box>
          }
        </Box>
      </Flex>
    </React.Fragment>)
  }
  )

  return (
    <Box mt='2em'>
      {displayReplies}
    </Box>
  );

}